(() => {
  function showSignupResponse() {
    document.querySelectorAll('[data-signup-success]').forEach(success => {
      const form = success.closest('form');
      // Shopify shares customer-form success across the page. Show only the
      // submitted form's confirmation, and never infer success from the URL alone.
      const submitted = form && location.hash === '#' + form.id;
      success.hidden = !submitted;
      const fields = form?.querySelector('[data-signup-fields]');
      if (fields) fields.hidden = !!submitted;
      if (!submitted || success.dataset.confirmationShown) return;
      success.dataset.confirmationShown = 'true';
      requestAnimationFrame(() => {
        success.focus({ preventScroll: true });
        success.scrollIntoView({ block: 'center', behavior: 'instant' });
      });
    });
  }
  showSignupResponse();
  document.addEventListener('shopify:section:load', showSignupResponse);
})();
